import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeCheckboxBaseComponent } from './e5core-ui-work-field-type-checkbox-base';

@Component({
  selector: 'e5core-ui-work-field-type-checkbox-bootstrap',
  templateUrl: './e5core-ui-work-field-type-checkbox-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-checkbox-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeCheckboxBootstrapComponent extends E5coreUiWorkFieldTypeCheckboxBaseComponent {
}

